import { useTranslations } from "next-intl";
import { type Resolver, useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

export interface InsuranceForm {
	insurance?: boolean;
	termsConsent: boolean;
}

const useInsuranceForm = () => {
	const t = useTranslations("pages.InsuranceSalePage");
	const required = t("errors.mandatoryField");

	const schema = z
		.object({
			insurance: z.boolean({
				error: required,
			}),
			termsConsent: z.boolean(),
		})
		.superRefine((data, ctx) => {
			if (!data.insurance) return;

			if (!data.termsConsent) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: required,
					path: ["termsConsent"],
				});
			}
		});

	return {
		useForm: useForm<InsuranceForm, unknown, InsuranceForm>({
			resolver: zodResolver(schema) as unknown as Resolver<
				InsuranceForm,
				unknown,
				InsuranceForm
			>,
			mode: "onTouched",
			defaultValues: {
				insurance: undefined,
				termsConsent: false,
			},
		}),
		schema,
	};
};

export default useInsuranceForm;
